import React from 'react';
import { func } from 'prop-types';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import clsx from 'clsx';
import classes from './AuthCore.module.css';

const ValidationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Must be an email address')
        .required('Email address required')
});

const ForgotPasswordForm = props => {
    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: ValidationSchema,
        onSubmit:         props.onSubmit
    });

    return (
        <React.Fragment>
            <h3>Forgot Your Password?</h3>
            <p className={classes.bottomText}>
                That’s okay, it happens! Enter your email address below and click on the button to reset your password.
            </p>
            <form
                onSubmit={formik.handleSubmit}
                className={classes.form}
            >
                <FormControl className={classes.formControl}>
                    <InputLabel
                        htmlFor="email"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                        error={Boolean(formik.errors.email) && Boolean(formik.touched.email)}
                    >
                        Email
                    </InputLabel>
                    <Input
                        id="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        classes={{
                            error:     classes.cssErrorUnderline,
                            underline: classes.cssUnderline,
                            root:      classes.input
                        }}
                        error={Boolean(formik.errors.email) && Boolean(formik.touched.email)}
                        inputProps={{
                            onBlur: formik.handleBlur
                        }}
                    />
                    {formik.touched.email &&
                     formik.errors.email && <FormHelperText className={classes.error}>{formik.errors.email}</FormHelperText>}
                </FormControl>
                <div className={clsx(classes.buttonContainer, classes.forgotPasswordButtonContainer)}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={formik.isSubmitting}
                        className={classes.primaryFullWidth}
                    >
                        Reset Password
                    </Button>
                </div>
            </form>
            <p>
                <b>Please note:</b> The verification code email will be sent from ‘no-reply@wennsoft.com’ email address. If you do not receive the email, check your junk mail, and add the contact to your safe senders list. Still having trouble finding your code, contact your IT department to ensure the ‘no-reply@wennsoft.com’ email address is not being blocked.
            </p>
        </React.Fragment>
    );
};

ForgotPasswordForm.defaultProps = {
    onSubmit: () => {}
};

ForgotPasswordForm.propTypes = {
    onSubmit: func
};

export default ForgotPasswordForm;
